import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

const camelCase = (s: string) =>
  s.toLowerCase().replace(/[^a-z0-9]+(.)/g, (_, c) => c.toUpperCase());

type Integration = {
  description: string;
  integrationId: string;
  integrationTypeId?: string;
  IntegrationTypes?: { description?: string };
};

export const IntegrationActionsCell = (props: {
  integration: Integration;
  onDeleted: () => void;
}) => {
  const [isDeleteOpen, toggleDeleteOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Delete', onSelect: toggleDeleteOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-${camelCase(props.integration.description)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmationText='DELETE'
        confirmColor='error'
        confirmText='Delete'
        data-testid={`delete-${camelCase(props.integration.description)}`}
        isOpen={isDeleteOpen}
        message={`Are you sure you want to delete "${props.integration.description}"? This action cannot be undone.`}
        onCancel={toggleDeleteOpen}
        onConfirm={() => {
          toggleDeleteOpen();
          props.onDeleted();
        }}
        title='Delete Integration'
      />
    </>
  );
};
